<template>
    <v-list nav dense>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/gestion_empresa">
                <v-list-tile-action>
                    <v-icon medium>business_center</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>Gestión de Empresa</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        <v-list-group
                v-if="!getProfile.enable_parking && getProfile.roll !== 8"
                append-icon="arrow_drop_down"
                active-class="white--text"
                prepend-icon="edit"
        >
            <v-list-tile slot="activator">
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Invitaciones')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/invitacion_tab">
                <v-list-tile-action>
                    <v-icon medium>event</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Invitacion')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/invitados_no_confirmados">
                <v-list-tile-action>
                    <v-icon medium>person_add_disabled</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('invitados_no_confirmados')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/firma_salida">
                <v-list-tile-action>
                    <v-icon medium>check_circle</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('firma_salida')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>            
            <v-divider></v-divider>      
        </v-list-group>
        <v-divider></v-divider>
        <v-list-tile v-if="getProfile.enable_parking === false && getProfile.roll !== 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/bitacora_empresa">
            <v-list-tile-action>
                <v-icon medium>work_history</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('Historial_Empleados')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                v-if="getProfile.id_company !== 62 && !getProfile.enable_parking && getProfile.roll !== 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/historial">
            <v-list-tile-action>
                <v-icon medium>date_range</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('Historial')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-else-if="!getProfile.enable_parking && getProfile.roll !== 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/bitacora">
            <v-list-tile-action>
                <v-icon medium>date_range</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('Historial')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-group
                v-if="getProfile.enable_parking === true"
                append-icon="arrow_drop_down"
                active-class="white--text"
                prepend-icon="local_parking"
        >
            <v-list-tile slot="activator">
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('parking_lot')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                    class="tile"
                    active-class="blue-grey darken-1 white--text"
                    router to="/reservations_owner">
                    <v-list-tile-action>
                        <v-icon medium>business</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <h3>Mis Espacios Reservados</h3>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <!-- <v-list-tile
                    class="tile"
                    active-class="blue-grey darken-1 white--text"
                    router to="/reservations_beneficiary">
                    <v-list-tile-action>
                        <v-icon medium>card_giftcard</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <h3>Espacios Reservados Recibidos</h3>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile> -->
                <v-list-tile
                    class="tile"
                    active-class="blue-grey darken-1 white--text"
                    router to="/reservations_history">
                    <v-list-tile-action>
                        <v-icon medium>history</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <h3>Historial de Reservas</h3>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            <!-- <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/mockup2">
                <v-list-tile-action>
                    <v-icon medium>event</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Invitacion')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile> -->
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/access_parking_records">
                <v-list-tile-action>
                    <v-icon medium>calendar_today</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Historial')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/mockup5">
                <v-list-tile-action>
                    <v-icon medium>map</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>Mapa de Estacionamiento</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/invitados_no_confirmados">
                <v-list-tile-action>
                    <v-icon medium>person_add_disabled</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('invitados_no_confirmados')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/clients2">
                <v-list-tile-action>
                    <v-icon medium>corporate_fare</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>Secciones</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/parking_space">
                <v-list-tile-action>
                    <v-icon medium>space_dashboard</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('parking_space')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/vehicle_types">
                <v-list-tile-action>
                    <v-icon medium>commute</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('vehicle_types')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <!-- <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/types_of_transport">
                <v-list-tile-action>
                    <v-icon medium>unarchive</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('types_of_transport')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile> -->
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
                v-if="getProfile.enable_shipments === true"
                append-icon="arrow_drop_down"
                active-class="white--text"
                prepend-icon="anchor"
        >
            <v-list-tile slot="activator">
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('shipments')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/mockup">
                <v-list-tile-action>
                    <v-icon medium>event</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Invitacion')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
               <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/mockup3">
                <v-list-tile-action>
                    <v-icon medium>anchor</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('supervise_shipments')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/mockup4">
                <v-list-tile-action>
                    <v-icon medium>anchor</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('informative_shipments')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                v-if="getProfile.enable_advanced_shipments"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/operator_metrics">
                <v-list-tile-action>
                    <v-icon medium>trending_up</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>Métricas de Operadores</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                v-if="getProfile.enable_advanced_shipments"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/vehicles_management">
                <v-list-tile-action>
                    <v-icon medium>directions_car</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>Gestión de Vehículos</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <!-- FASE 1-6: Embarques Avanzados - Menú Plano sin Submenús -->
            <!-- Transportistas -->
            <v-list-tile
                v-if="getProfile.enable_advanced_shipments"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/advanced-shipments/carriers">
                <v-list-tile-action>
                    <v-icon medium>local_shipping</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>Transportistas</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <!-- Emails de Evidencia -->
            <v-list-tile
                v-if="getProfile.enable_advanced_shipments"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/advanced-shipments/evidence-emails">
                <v-list-tile-action>
                    <v-icon medium>email</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>Emails de Evidencia</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/access_shipments_records">
                <v-list-tile-action>
                    <v-icon medium>calendar_today</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Historial')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/clients">
                <v-list-tile-action>
                    <v-icon medium>corporate_fare</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>Plantas Destino</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/landing_areas">
                <v-list-tile-action>
                    <v-icon medium>forklift</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('landing_area')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/types_of_transport">
                <v-list-tile-action>
                    <v-icon medium>unarchive</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('types_of_transport')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
                v-if="getProfile.enable_security === true"
                append-icon="arrow_drop_down"
                active-class="white--text"
                prepend-icon="security"
        >
            <v-list-tile slot="activator">
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('security_patrimonial_menu')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                    class="tile"
                    active-class="blue-grey darken-1 white--text"
                    router to="/security/dashboard">
                <v-list-tile-action>
                    <v-icon medium>dashboard</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title><h3>{{$t('security_module')}}</h3></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                    class="tile"
                    active-class="blue-grey darken-1 white--text"
                    router to="/security/geofences">
                <v-list-tile-action>
                    <v-icon medium>map</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title><h3>{{$t('security_geofences')}}</h3></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list-group>
        <v-list-tile
                v-if="getProfile.roll == 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/admin">
            <v-list-tile-action>
                <v-icon medium>security</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('security_admin_panel')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-if="getProfile.roll == 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/guards">
            <v-list-tile-action>
                <v-icon medium>group</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('security_manage_guards')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-if="getProfile.roll == 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/roll-call">
            <v-list-tile-action>
                <v-icon medium>qr_code</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>Pase de Lista</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-if="getProfile.roll == 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/roll-call-history">
            <v-list-tile-action>
                <v-icon medium>history</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>Historial de Pase de Lista</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-if="getProfile.roll == 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/shifts">
            <v-list-tile-action>
                <v-icon medium>schedule</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('security_active_shifts')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-if="getProfile.roll == 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/shift-history">
            <v-list-tile-action>
                <v-icon medium>history</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>Historial de Turnos</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-if="getProfile.roll == 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/document-requests">
            <v-list-tile-action>
                <v-icon medium>description</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>Solicitudes de Documentos</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-if="getProfile.roll == 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/security/messages">
            <v-list-tile-action>
                <v-icon medium>notifications</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>Comunicados y Consignas</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-group
                v-if="getProfile.roll !== 8"
                append-icon="arrow_drop_down"
                active-class="white--text"
                prepend-icon="menu_book"
        >
            <v-list-tile slot="activator">
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('catalogos')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/empleados">
                <v-list-tile-action>
                    <v-icon medium>person</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Empleados')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/vigilantes">
                <v-list-tile-action>
                    <v-icon medium>assignment_ind</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Vigilantes')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/proveedores">
                <v-list-tile-action>
                    <v-icon medium>airport_shuttle</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('proveedores')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                v-if="getProfile.enable_contractors === true"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/admin_workers">
                <v-list-tile-action>
                    <v-icon medium>engineering</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('workers')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/areas">
                <v-list-tile-action>
                    <v-icon medium>store</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Areas')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/casetas">
                <v-list-tile-action>
                    <v-icon medium>local_convenience_store</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        <h3>{{$t('Casetas')}}</h3>
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-tile
                v-if="getProfile.roll !== 8"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/banned_people">
            <v-list-tile-action>
                <v-icon medium>no_accounts</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('banned_people')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/emergencia">
            <v-list-tile-action>
                <v-icon medium>warning</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('boton_emergencia')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                v-if="getProfile.has_transport_service"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/personal_transport">
            <v-list-tile-action>
                <v-icon medium>directions_bus</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>Transporte de Personal</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/configuracion">
            <v-list-tile-action>
                <v-icon medium>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('configuracion')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/ayuda_admin">
            <v-list-tile-action>
                <v-icon medium>help</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile-title><h3>{{$t('Ayuda')}}</h3></v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "admin",
        computed: {
          ...mapGetters(['getProfile'])
        },
        data () {
            return {
            }
        }
    }
</script>
